import { render, staticRenderFns } from "./ManageProduct.vue?vue&type=template&id=a0026106&scoped=true"
import script from "./ManageProduct.vue?vue&type=script&lang=js"
export * from "./ManageProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0026106",
  null
  
)

export default component.exports